module.exports = __webpack_public_path__ + "static/media/img_26.99e07713.png";